import React, { useEffect } from "react";
import { useStudentsLists } from "../../../hooks/students/useStudentsLists.hooks";
import { useStudentListFilters } from "../../../hooks/filterHooks/useStudentFilterHooks";
import { StudentList } from "./StudentsList";

export const GraduatedStudentList = () => {
  const { filters } = useStudentListFilters("GRADUATED_STUDENT");

  const { isLoading: isStudentsListLoading, data: studentsList } =
    useStudentsLists({
      page: filters?.page,
      filters: {
        ...(filters || {}),
        onlyGraduatedStudents: true,
      },
    });

  return (
    <StudentList
      isStudentsListLoading={isStudentsListLoading}
      studentsList={studentsList}
      studentListNameSpace="GRADUATED_STUDENT"
    />
  );
};
